export default {


    countConditions(template){
        console.log(template)
        template.sections.forEach(section => {
            // console.log(section)
            let sentence = section.sentences.sentences
            // console.log(sentence)
            sentence.forEach(subSentence =>{
            //    console.log(subSentence.conditionList.conditions)
                let conditions = subSentence.conditionList.conditions
                getConditionsRecursively(conditions)
                // let getRecurse = recurse(conditions);
                // console.log(getRecurse)
                
            })
        })

      function  getConditionsRecursively(conditions) {
          console.log(conditions)
        let allConds = 0
          let total;
            if(!conditions){
                console.log("Stop")
                return 0
            }
            if(conditions.subconditions == 0){
                
                console.log("+1")
                 return 1
            }
            else{
                total = 0
                conditions.forEach(c =>{
                    let subC = c.subconditions.conditions
                    console.log("c" , subC)
                    total +=  getConditionsRecursively(subC)
                    allConds =+ total.length
                    return total
                })

                console.log("asd", total.length)
            }

            console.log("aooooolll",allConds)
        }
        
        
        
        
        
        // let recurse = function rec(conditions){
        //     let allConds = 0
        //     let total;
        //     if(!conditions){
        //         // console.log("Stop")
        //         return 0
        //     }
        //     if(conditions == 0){
                
        //         // console.log("+1")
        //         return total += 1
        //     }
        //     else{
        //         total = 0
        //         conditions.forEach(c =>{
        //             total +=  getConditionsRecursively(c)
        //             // allConds =+ total.length
        //             return total
        //         })
                
        //         // console.log("asd", total.length)
        //     }
            
        //     console.log("aooooolll",allConds)
        // }


     
    }
}
